import { posImageAxiosClient } from '@kinderlabs-pos/apis/axios';

export const uploadWarehouseOrderFilesAsync =
	(rootUrl: string) =>
	async ({ id, fileData }: { id: number; fileData: FormData }) => {
		return (
			await posImageAxiosClient.put(`${rootUrl}/warehouse-order/file`, fileData, {
				params: {
					id: id,
				},
			})
		).data;
	};
